<div
  class="fgbcl-games-details-card fgbcl-games-predictor-details-card"
  [ngClass]="{
    'fgbcl-games-predictor-details-multi-card': predictor.Questions.length > 1,
    'fgbcl-games-predictor-details-single-card': predictor.Questions.length == 1,
  }"
>
  <div *ngIf="loadingState" class="fgbcl-game-overlay"></div>

  <ng-container *ngIf="(!predictor.Processed && !isExternal) || (isExternal && !allAnswersSubmitted()); else showResults">
    <div class="fgbcl-games-predictor-question-section-countdown">
      <div class="fgbcl-games-predictor-countdown-end-text" *ngIf="predictor.Questions.length > 1">
        {{ 'fgbcl.game.predictor.ends.text' | translate }}:
      </div>
      <fgbcl-countdown-v2 [endDateTime]="endDate" completeText="Ended" (complete)="predictorEnded()"></fgbcl-countdown-v2>
    </div>
    <ng-container *ngFor="let question of predictor.Questions; let i = index">
      <div
        [ngClass]="{
          'fgbcl-games-predictor-question-card': predictor.Questions.length > 1,
        }"
      >
        <div *ngIf="predictor.Questions.length > 1" class="fgbcl-games-predictor-question-number-circle">{{ i + 1 }}</div>
        <div class="fgbcl-games-predictor-question-item">
          <fgbcl-games-question-item
            [question]="question"
            [groupType]="groupType"
            [currentQuestionIndex]="question.Id"
            (answerSelected)="onAnswerSelected(question.Id, $event)"
          ></fgbcl-games-question-item>
        </div>
      </div>
    </ng-container>
    <div class="fgbcl-game-predictor-save-button-section">
      <button
        [disabled]="!canSubmitPrediction() && predictorStatus != 'resume'"
        class="fgbcl-game-predictor-save-button"
        [ngClass]="{
          'game-disable-button': !canSubmitPrediction(),
          'fgbcl-game-predictor-save-button-not-submitted': canSubmitPrediction() || predictorStatus == 'resume',
        }"
        (click)="savePrediction()"
      >
        <span *ngIf="loadingState" class="spinner-border" style="width: 1rem; height: 1rem" role="status"></span>
        <!-- Button text -->
        <span>
          {{ 'fgbcl.game.predictor.save.button.text' | translate }}
        </span>
      </button>
      <!-- <p class="fgbcl-games-save-predictor-description" *ngIf="predictionsSubmitted">
        {{ 'fgbcl.game.save.predictor.description' | translate }}
      </p> -->
    </div>
  </ng-container>

  <ng-template #showResults>
    <fgbcl-game-predictor-result
      [predictorResult]="predictor"
      [sharedRedirectURL]="sharedRedirectURL"
      [isExternal]="isExternal"
    >
    <ng-template #submissionFormContent>
      <ng-container *ngTemplateOutlet="submissionFormTemplate"></ng-container>
    </ng-template>
  </fgbcl-game-predictor-result>
  </ng-template>
</div>
